import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';

import ProtectedRoute from './ProtectedRoute';
import Login from './Login';
import Register from './Register';
import Reset from './Reset';
import theme from '../configs/theme';
import MainContainer from '../containers/MainContainer';
import './App.css';

class App extends Component {
  render() {
    if (this.props.checkingJWT) {
      return <div className="App" />;
    } else {
      return (
        <div className="App">
          <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
          <Switch>
            <Route
              exact
              path="/login"
              render={props => (
                <Login handleLogin={this.props.handleLoginSuccess} isLoggedIn={this.props.isLoggedIn} {...props} />
              )}
            />
            <Route
              exact
              path="/register"
              render={props => <Register handleLogin={this.props.handleLoginSuccess} {...props} />}
            />
            <Route path="/reset" render={props => <Reset handleLogin={this.props.handleLoginSuccess} {...props} />} />
            <ProtectedRoute path="/" component={MainContainer} isLoggedIn={this.props.isLoggedIn} />
          </Switch>
          </MuiPickersUtilsProvider>
          </MuiThemeProvider>
        </div>
      );
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js